import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import router, { resetRouter } from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect', '/wxcode-redirect']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, roles, accessRoutes;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 33;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 9;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.next = 31;
          break;
        case 9:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 14;
            break;
          }
          next();
          _context.next = 31;
          break;
        case 14:
          _context.prev = 14;
          _context.next = 17;
          return store.dispatch('user/getInfo');
        case 17:
          _yield$store$dispatch = _context.sent;
          roles = _yield$store$dispatch.roles;
          _context.next = 21;
          return store.dispatch('permission/generateRoutes', roles);
        case 21:
          accessRoutes = _context.sent;
          //  console.log(accessRoutes,'accessRoutes')
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 31;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](14);
          // remove token and go to login page to re-login
          // await store.dispatch('user/resetToken')
          Message.error(_context.t0 || 'Has Error');
          next("/404");
          NProgress.done();
        case 31:
          _context.next = 34;
          break;
        case 33:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 34:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 26]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});